import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { AUTHOR_INFO } from 'src/app/onelog/common/config/url';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import {
  DROP_DOWN_SETTING_BOOKTYPE, DEFAULT_AUTHOR_INFO_STATUSES
} from 'src/app/onelog/common/config/dropdown-config';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-author-information',
  templateUrl: './author-information.component.html',
  styleUrls: ['./author-information.component.css']
})
export class AuthorInformationComponent implements OnInit {
  constructor(
    private _requestService: RequestService,
    private _productStatus: ProductSatusService
  ) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectedStatus: any = [...DEFAULT_AUTHOR_INFO_STATUSES];
  dropdownListStatus: any = [];
  listStatus: any = [];
  dropdownSettingsBookType: IDropdownSettings = {};
  selectedDefaultItemsStatus: any = [...DEFAULT_AUTHOR_INFO_STATUSES];
  selectedStatusFilter: any = [];

  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;

  ngOnInit(): void {
    this.loadProductStatusList();
    this.loadProducts(this.createPostData());
    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;
  }
  
  loadProductStatusList() {
    return this._productStatus.getStatusList().subscribe((data: {}) => {
      this.listStatus = data;
      let statusList: any = [];
 
      let tempSelectedDd: any = [];
      this.listStatus.data.forEach(function (currentValue: any, index: any, arr: any) {
        let obj: any = {};
        obj['item_id'] = currentValue.attributes.name;
        obj['item_text'] = currentValue.attributes.name;
        statusList.push(obj);
      });

      this.dropdownListStatus = statusList;

      this.loadProducts(this.createPostData());
    });
  }

    loadProducts(postData: any = [], url: string = AUTHOR_INFO) {
      return this._requestService
        .postRequest(url, postData)
        .subscribe((data: {}) => {
          this.responseData = data;
          this.products = data;
          if (this.products.length > 0) {
            this.totalProducts = (
              data as { total_count: number }[]
            )[0].total_count;
          }else{
            this.totalProducts = 0
          }
          this.perPage = 25;
          this.lastPage = Math.floor(this.totalProducts / 25) + 1;
          //console.log(this.products);
          this.searchBtnText = 'Search';
          this.showSearchLoading = false;
        });
    }

    createPostData() {
      this.setStatusFilterData();

      return {
        selectedStatus: Object.assign({}, this.selectedStatusFilter),
        page: this.currentPage,
      };
      
    }

    setStatusFilterData() {
    if ( this.selectedStatus.length > 0 ) {
      this.selectedStatusFilter['selected'] = this.selectedStatus;
    }

  }

    updateSelectedType(event: any) {
      const data: any = event;

      if (event.type == 'status') {
              if (data.action == 'selected') {
                this.selectedStatus.push(data.item.item_text);
              } else {
                const index = this.selectedStatus.indexOf(data.item.item_text);
                this.selectedStatus.splice(index, 1);
              }
              if (data.action == 'deSelectedAll') {
                this.selectedStatus = [];
                this.selectedDefaultItemsStatus = [];
                this.selectedStatusFilter = {};
              }
      }
    }
  
    searchProduct() {
      this.searchBtnText = 'Searching...';
      this.showSearchLoading = true;
  

  
      this.loadProducts(this.createPostData());
      this.searchBtnText = 'Search';
      this.showSearchLoading = false;
    }
  
    updatePageData(event: Event) {
      let eventData: any = event;
      let urlParams = '?page=' + eventData.currentPage;
      this.currentPage = eventData.currentPage;
      //console.log(eventData, urlParams);
      this.loadProducts(this.createPostData());
    }
  
    clearFilters() {
        (this.selectedStatus = [...DEFAULT_AUTHOR_INFO_STATUSES] ),
        (this.selectedDefaultItemsStatus = [...DEFAULT_AUTHOR_INFO_STATUSES]),
        (this.selectedStatusFilter = {})
        //this.clearAllDropDowns();
    }
  
    clearAllDropDowns() {
      this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
        DropDownComp.clearInput();
      });
    }

      downloadReport() {
        this._requestService.download(
          AUTHOR_INFO,
          {
            is_download: 1,
            selectedStatus: Object.assign({}, this.selectedStatusFilter),
            page: this.currentPage,
          },
          '',
          'author_information'
        );
      }

}
